import { render, staticRenderFns } from "./veStuCheckItemNormEdit.vue?vue&type=template&id=6b63e2e4&scoped=true"
import script from "./veStuCheckItemNormEdit.vue?vue&type=script&lang=js"
export * from "./veStuCheckItemNormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63e2e4",
  null
  
)

export default component.exports